import * as schemaDefaultsImp from './lib/schema-defaults';
import * as sfPathImp from './lib/sf-path';
import canonicalTitleMapImp from './lib/canonical-title-map';

export { merge } from './lib/merge';
export { select }  from './lib/select';
export { jsonref }  from './lib/resolve';
export { traverseSchema, traverseForm } from './lib/traverse';
export { validate } from './lib/validate';

export const sfPath = sfPathImp;
export const schemaDefaults = schemaDefaultsImp;
export const canonicalTitleMap = canonicalTitleMapImp;



// WEBPACK FOOTER //
// ./src/module.js